import { createTheme } from '@mui/material'


export const theme = createTheme({
  typography: {
    fontFamily: 'Red Hat Display',
  }
})
